   window.addEventListener('DOMContentLoaded', function() {

$(document).ready(function(){
  if($(window).width() < 767){
      $('.facets-popup-modal--tab[data-index="1"] .filter_tab').addClass('active_tab');
   $('.facets-popup-modal--tab[data-index="1"] .filter_sub_list').show();
  }else{
    $('.facets-popup-modal--tab[data-index="1"]').removeClass('active');
  }
    $('.facets-popup-modal--tab .filter_sub_list').hide();
   $(document).on('click','.filter_tab',function(){
    $(this).parents('.facets-popup-modal--tab').toggleClass('active');
    $('.facets-popup-modal--tab').not($(this).parents('.facets-popup-modal--tab')).removeClass('active');
    $(this).toggleClass('active_tab');
    $('.filter_tab').not($(this)).removeClass('active_tab');
    $('.filter_sub_list').not($(this).parents('.facets-popup-modal--tab').find('.filter_sub_list')).slideUp();
    $(this).parents('.facets-popup-modal--tab').find('.filter_sub_list').slideToggle();
})
})
})